import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteUser = (data, callback, errorCallBack) => { 
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.DELETE_USER,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteUser
